import { AI_ASSET_KINDS } from "./constants";

const compact = (value) => {
  if (value === undefined || value === null || value === "") return undefined;
  return value;
};

const toOptionalUserId = (value) => {
  if (value === undefined || value === null || value === "" || value === "null") {
    return undefined;
  }

  const id = Number(value);

  if (!Number.isFinite(id) || id === 0) {
    return undefined;
  }

  return id;
};

export const buildSoftwarePayload = ({
  assetKind,
  detection,
  developmentUsageScope,
  documentValues,
  hostingEvidence,
  hostingLocationIds,
  intendedPurpose,
  isAiSystem,
  isOwnDevelopment,
  legalEntityValues,
  moduleValues,
  nonEuHostingLocationIds,
  notice,
  operatingSystem,
  owner,
  aiGovernanceResponsible,
  itSecurityResponsible,
  provider,
  serviceName,
  softwareUrl,
  subscription,
  type,
  version,
}) => {
  const payload = {
    service: serviceName,
    isOwnDevelopment: !!isOwnDevelopment,
    hostingEvidence: Array.isArray(hostingEvidence) ? hostingEvidence : [],
    legalEntities: (legalEntityValues || [])
      .map((id) => String(id))
      .filter((id) => id && id !== "undefined" && id !== "null"),
  };

  if (detection && typeof detection === "object") {
    payload.aiSystemDetection = detection;
  }

  if (owner) {
    payload.owner = Number(owner);
  }
  const aiGovernanceResponsibleId = toOptionalUserId(aiGovernanceResponsible);
  if (aiGovernanceResponsibleId) {
    payload.aiGovernanceResponsible = aiGovernanceResponsibleId;
  }
  const itSecurityResponsibleId = toOptionalUserId(itSecurityResponsible);
  if (itSecurityResponsibleId) {
    payload.itSecurityResponsible = itSecurityResponsibleId;
  }
  if (moduleValues?.length) {
    payload.modules = moduleValues;
  }
  if (hostingLocationIds?.length) {
    payload.hostingLocations = hostingLocationIds;
  }
  if (nonEuHostingLocationIds?.length) {
    payload.noneEUHostingLocations = nonEuHostingLocationIds;
  }
  if (documentValues?.length) {
    payload.resources = documentValues;
  }
  if (compact(version)) {
    payload.version = version;
  }
  if (compact(operatingSystem)) {
    payload.operatingSystem = operatingSystem;
  }

  if (isOwnDevelopment) {
    payload.developmentUsageScope = developmentUsageScope;
    payload.intendedPurpose = (intendedPurpose || "").trim();
    payload.assetKind = assetKind;
    if (compact(softwareUrl)) {
      payload.url = softwareUrl;
    }
    if (isAiSystem === true || isAiSystem === false) {
      payload.isAiSystem = isAiSystem;
    } else if (AI_ASSET_KINDS.includes(assetKind)) {
      payload.isAiSystem = true;
    }
    return payload;
  }

  payload.isAiSystem = !!isAiSystem;
  payload.url = softwareUrl;
  payload.provider = provider;
  payload.type = type;
  payload.notice = notice || null;
  payload.subscription = !!subscription;
  return payload;
};
